/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAuthenticationConstraint } from './UserAuthenticationConstraint';
import {
    UserAuthenticationConstraintFromJSON,
    UserAuthenticationConstraintFromJSONTyped,
    UserAuthenticationConstraintToJSON,
    UserAuthenticationConstraintToJSONTyped,
} from './UserAuthenticationConstraint';
import type { AdgangAccessControl } from './AdgangAccessControl';
import {
    AdgangAccessControlFromJSON,
    AdgangAccessControlFromJSONTyped,
    AdgangAccessControlToJSON,
    AdgangAccessControlToJSONTyped,
} from './AdgangAccessControl';
import type { PermissionResponse } from './PermissionResponse';
import {
    PermissionResponseFromJSON,
    PermissionResponseFromJSONTyped,
    PermissionResponseToJSON,
    PermissionResponseToJSONTyped,
} from './PermissionResponse';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';
import type { AccessRequestApprovalType } from './AccessRequestApprovalType';
import {
    AccessRequestApprovalTypeFromJSON,
    AccessRequestApprovalTypeFromJSONTyped,
    AccessRequestApprovalTypeToJSON,
    AccessRequestApprovalTypeToJSONTyped,
} from './AccessRequestApprovalType';

/**
 * 
 * @export
 * @interface RoleResponse
 */
export interface RoleResponse {
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    applicationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    applicationName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponse
     */
    canBeRequestedByUsers?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponse
     */
    isGlobal?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    name?: string | null;
    /**
     * 
     * @type {any}
     * @memberof RoleResponse
     */
    roleId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    tags?: string | null;
    /**
     * 
     * @type {UserType}
     * @memberof RoleResponse
     */
    userType?: UserType;
    /**
     * 
     * @type {UserAuthenticationConstraint}
     * @memberof RoleResponse
     */
    userAuthenticationConstraint?: UserAuthenticationConstraint;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponse
     */
    requireUserOrganizationInMinSide?: boolean | null;
    /**
     * 
     * @type {AccessRequestApprovalType}
     * @memberof RoleResponse
     */
    accessRequestApprovalType?: AccessRequestApprovalType;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponse
     */
    requiresMfa?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponse
     */
    allowEndUserCreation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponse
     */
    allowEndUserAssignment?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponse
     */
    unlocksExternalApproverRights?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponse
     */
    isSystemRole?: boolean;
    /**
     * 
     * @type {Array<any>}
     * @memberof RoleResponse
     */
    organizationGroupIds?: Array<any> | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof RoleResponse
     */
    permissionIds?: Array<any> | null;
    /**
     * 
     * @type {Array<PermissionResponse>}
     * @memberof RoleResponse
     */
    permissions?: Array<PermissionResponse> | null;
    /**
     * 
     * @type {any}
     * @memberof RoleResponse
     */
    accessExpirationId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponse
     */
    requiresReasonForAsking?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    helpTextReasonField?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    entraSecurityGroupId?: string | null;
    /**
     * 
     * @type {Array<AdgangAccessControl>}
     * @memberof RoleResponse
     */
    accessControls?: Array<AdgangAccessControl> | null;
}



/**
 * Check if a given object implements the RoleResponse interface.
 */
export function instanceOfRoleResponse(value: object): value is RoleResponse {
    return true;
}

export function RoleResponseFromJSON(json: any): RoleResponse {
    return RoleResponseFromJSONTyped(json, false);
}

export function RoleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'applicationName': json['applicationName'] === undefined ? undefined : json['applicationName'] === null ? null : json['applicationName'],
        'canBeRequestedByUsers': json['canBeRequestedByUsers'] == null ? undefined : json['canBeRequestedByUsers'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'isGlobal': json['isGlobal'] == null ? undefined : json['isGlobal'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'roleId': json['roleId'] === undefined ? undefined : json['roleId'] === null ? null : json['roleId'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'tags': json['tags'] === undefined ? undefined : json['tags'] === null ? null : json['tags'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'userAuthenticationConstraint': json['userAuthenticationConstraint'] == null ? undefined : UserAuthenticationConstraintFromJSON(json['userAuthenticationConstraint']),
        'requireUserOrganizationInMinSide': json['requireUserOrganizationInMinSide'] === undefined ? undefined : json['requireUserOrganizationInMinSide'] === null ? null : json['requireUserOrganizationInMinSide'],
        'accessRequestApprovalType': json['accessRequestApprovalType'] == null ? undefined : AccessRequestApprovalTypeFromJSON(json['accessRequestApprovalType']),
        'requiresMfa': json['requiresMfa'] == null ? undefined : json['requiresMfa'],
        'allowEndUserCreation': json['allowEndUserCreation'] == null ? undefined : json['allowEndUserCreation'],
        'allowEndUserAssignment': json['allowEndUserAssignment'] == null ? undefined : json['allowEndUserAssignment'],
        'unlocksExternalApproverRights': json['unlocksExternalApproverRights'] == null ? undefined : json['unlocksExternalApproverRights'],
        'isSystemRole': json['isSystemRole'] == null ? undefined : json['isSystemRole'],
        'organizationGroupIds': json['organizationGroupIds'] === undefined ? undefined : json['organizationGroupIds'] === null ? null : json['organizationGroupIds'],
        'permissionIds': json['permissionIds'] === undefined ? undefined : json['permissionIds'] === null ? null : json['permissionIds'],
        'permissions': json['permissions'] === undefined ? undefined : json['permissions'] === null ? null : ((json['permissions'] as Array<any>).map(PermissionResponseFromJSON)),
        'accessExpirationId': json['accessExpirationId'] === undefined ? undefined : json['accessExpirationId'] === null ? null : json['accessExpirationId'],
        'requiresReasonForAsking': json['requiresReasonForAsking'] == null ? undefined : json['requiresReasonForAsking'],
        'helpTextReasonField': json['helpTextReasonField'] === undefined ? undefined : json['helpTextReasonField'] === null ? null : json['helpTextReasonField'],
        'entraSecurityGroupId': json['entraSecurityGroupId'] === undefined ? undefined : json['entraSecurityGroupId'] === null ? null : json['entraSecurityGroupId'],
        'accessControls': json['accessControls'] === undefined ? undefined : json['accessControls'] === null ? null : ((json['accessControls'] as Array<any>).map(AdgangAccessControlFromJSON)),
    };
}

export function RoleResponseToJSON(json: any): RoleResponse {
    return RoleResponseToJSONTyped(json, false);
}

export function RoleResponseToJSONTyped(value?: RoleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'applicationName': value['applicationName'],
        'canBeRequestedByUsers': value['canBeRequestedByUsers'],
        'description': value['description'],
        'isGlobal': value['isGlobal'],
        'name': value['name'],
        'roleId': value['roleId'],
        'shortName': value['shortName'],
        'tags': value['tags'],
        'userType': UserTypeToJSON(value['userType']),
        'userAuthenticationConstraint': UserAuthenticationConstraintToJSON(value['userAuthenticationConstraint']),
        'requireUserOrganizationInMinSide': value['requireUserOrganizationInMinSide'],
        'accessRequestApprovalType': AccessRequestApprovalTypeToJSON(value['accessRequestApprovalType']),
        'requiresMfa': value['requiresMfa'],
        'allowEndUserCreation': value['allowEndUserCreation'],
        'allowEndUserAssignment': value['allowEndUserAssignment'],
        'unlocksExternalApproverRights': value['unlocksExternalApproverRights'],
        'isSystemRole': value['isSystemRole'],
        'organizationGroupIds': value['organizationGroupIds'],
        'permissionIds': value['permissionIds'],
        'permissions': value['permissions'] == null ? undefined : ((value['permissions'] as Array<any>).map(PermissionResponseToJSON)),
        'accessExpirationId': value['accessExpirationId'],
        'requiresReasonForAsking': value['requiresReasonForAsking'],
        'helpTextReasonField': value['helpTextReasonField'],
        'entraSecurityGroupId': value['entraSecurityGroupId'],
        'accessControls': value['accessControls'] == null ? undefined : ((value['accessControls'] as Array<any>).map(AdgangAccessControlToJSON)),
    };
}

